import { Client } from '../interfaces/entities/client'
import { contacts } from './contacts'
import { advertiserUsers } from './advertiserUser'

export const clients: Client[] = [
  {
    id: '1',
    name: 'Client 1',
    contacts: contacts,
    pmContacts: contacts,
    advertiserUsers: advertiserUsers,
  },
  {
    id: '2',
    name: 'Client 2',
    contacts: contacts,
    pmContacts: contacts,
    advertiserUsers: advertiserUsers,
  },
  {
    id: '3',
    name: 'Client 3',
    contacts: contacts,
    pmContacts: contacts,
    advertiserUsers: advertiserUsers,
  },
]
